<MachineHistorySearch headerTextDM="DM Machines History" detailsType="Dialysis Machines">
